var _style, _g, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCert(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\uB808\\uC774\\uC5B4_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 420.8 420.8",
    style: {
      enableBackground: "new 0 0 420.8 420.8"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{display:none;}\n\t.st1{fill:none;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_1",
    className: "st0"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "\\uB808\\uC774\\uC5B4_8"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M330.9,324l-38.5-93c-1-2.4-3.7-3.5-6.1-2.5s-3.5,3.7-2.5,6.1l34.8,84.1l-31.8-9.2c-2.1-0.6-4.3,0.3-5.4,2.2l-16,29 L228,250.4c43.3-8.4,76-46.4,76-92c0-51.6-42-93.6-93.6-93.6s-93.6,42-93.6,93.6c0,20.9,6.9,40.2,18.5,55.8L89.9,324 c-0.7,1.7-0.4,3.5,0.8,4.9c1.2,1.3,3,1.9,4.8,1.4l37.5-10.9l18.8,34.2c0.8,1.5,2.4,2.4,4.1,2.4c0.1,0,0.2,0,0.3,0 c1.8-0.1,3.4-1.2,4-2.9l36-86.9c1-2.4-0.1-5.1-2.5-6.1s-5.1,0.1-6.1,2.5l-32.3,78l-16-29c-1-1.9-3.3-2.8-5.4-2.2l-31.8,9.2 l39.9-96.3c17.1,18.3,41.4,29.7,68.4,29.7c2.8,0,5.5-0.1,8.3-0.4l42,101.4c0.7,1.7,2.3,2.8,4,2.9c0.1,0,0.2,0,0.3,0 c1.7,0,3.2-0.9,4.1-2.4l18.8-34.2l37.5,10.9c1.7,0.5,3.6,0,4.8-1.4C331.3,327.5,331.6,325.6,330.9,324L330.9,324z M126.1,158.4 c0-46.5,37.8-84.3,84.3-84.3s84.3,37.8,84.3,84.3s-37.8,84.3-84.3,84.3S126.1,204.9,126.1,158.4L126.1,158.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M264.1,141c-0.5-1.6-1.9-2.9-3.6-3.1l-31.3-5.2l-14.6-28.1c-0.8-1.5-2.4-2.5-4.1-2.5c-1.7,0-3.3,1-4.1,2.5l-14.6,28.1 l-31.3,5.2c-1.7,0.3-3.1,1.5-3.6,3.1s-0.1,3.5,1.1,4.7l22.2,22.6l-4.7,31.4c-0.3,1.7,0.5,3.4,1.9,4.4s3.3,1.2,4.8,0.4l28.4-14.1 l28.4,14.1c0.7,0.3,1.4,0.5,2.1,0.5c1,0,1.9-0.3,2.7-0.9c1.4-1,2.1-2.7,1.9-4.4l-4.7-31.4l22.2-22.6 C264.2,144.5,264.6,142.6,264.1,141z M232.5,163.5c-1,1-1.5,2.5-1.3,3.9l3.7,24.8L212.5,181c-0.7-0.3-1.4-0.5-2.1-0.5 c-0.7,0-1.4,0.2-2.1,0.5l-22.5,11.2l3.7-24.8c0.2-1.4-0.3-2.9-1.3-3.9l-17.6-17.9l24.8-4.2c1.4-0.2,2.7-1.1,3.4-2.4l11.6-22.3 L222,139c0.7,1.3,1.9,2.2,3.4,2.4l24.8,4.2L232.5,163.5L232.5,163.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M280.8,163.1c-2.5-0.3-4.9,1.5-5.2,4c-4.3,32.5-32.3,57.1-65.2,57.1c-36.2,0-65.7-29.5-65.7-65.7s29.5-65.7,65.7-65.7 c32.8,0,60.8,24.5,65.2,57.1c0.3,2.5,2.7,4.3,5.2,4s4.3-2.7,4-5.2c-4.9-37.1-36.9-65.1-74.4-65.1c-41.4,0-75,33.7-75,75 s33.7,75,75,75c37.5,0,69.5-28,74.4-65.1C285.1,165.8,283.3,163.5,280.8,163.1L280.8,163.1z"
  })), /*#__PURE__*/React.createElement("rect", {
    y: 0,
    className: "st1",
    width: 420.8,
    height: 420.8
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCert);
export default __webpack_public_path__ + "static/media/cert.06921f56.svg";
export { ForwardRef as ReactComponent };